import xw from 'xwind';
import styled from '@emotion/styled';

const FormGroup = styled.div(xw`w-full mb-2 text-gray-700 md:mb-5`);

export default FormGroup;
